import { useEffect, useState } from "react";

/**
 * Returns `value` delayed by `delayMs` — used to debounce the shared Topbar
 * search before it drives the Users query (avoids a refetch per keystroke).
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
